import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/interconsulta";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllInterconsultaByTax(params.tratamientoId);
}

export function InterconsultaList(props) {
  const [interconsultaList, setInterconsulta] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    if (props.userRole.includes('administrador')) {
      API.getAllInterconsultaByTax(props.id).then(setInterconsulta).catch(console.log);
    } else {
      API.getAllInterconsultaByTaxAndEspecialista(props.id, props.especialistaId).then(setInterconsulta).catch(console.log);
    }
  }, [props.id]);
  return (
    <>
      {interconsultaList?.length ? (
          <ul className="interconsulta cpt-list">
            {interconsultaList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((interconsulta) => (
                <li key={interconsulta.id}>
                  <NavLink to={`${props.id}/interconsultas/${interconsulta.id}`}>{`${FormatDate(interconsulta.meta.metaFecha)} ${interconsulta.meta.interAsu}`}</NavLink>
                </li>
              ))}
          </ul>

          ) : (
            <></>
          )}
    </>
  );
}



export function InterconsultaListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Interconsultas</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}